export enum ServiceRequestFields {
  CATEGORY = "category",
  SUB_CATEGORY = "subcategory",
  HAS_PETS = "has_pets",
  HAS_SICKNESS = "is_household_sick",
  HAS_PERMISSION = "has_permission",
  PHONE = "phone",
  BRIEF_DESCRIPTION = "brief_description",
  DESCRIPTION = "description",
}
